import dataPeriTarMon from "../../../../src/data/periprocedureel-beleid-tar-mon-clo-asa.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarMon,
  BasicCollapse,
  React
};